import styled, { css } from 'styled-components';
import { isTablet } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA } from '../../../../utils/mobileSupported';
import { getResponsiveValue } from '../../../../utils/globalMethods';
import { ShadowLayer, Tooltip } from '..';
import {
  CheckRewardsStepTooltipTopPosConditions,
  CheckRewardsStepTooltipTopPosConditionsTablet,
  CheckRewardsStepTopLayerHeightConditions,
  CheckRewardsStepTopLayerHeightConditionsTablet,
  CheckRewardsStepBottomLayerTopConditions,
  CheckRewardsStepBottomLayerTopConditionsTablet,
} from './conditions';

const tooltipSmallScreen = css`
  top: ${({ $windowHeight }) =>
    getResponsiveValue({
      windowHeight: $windowHeight,
      conditions: isTablet ? CheckRewardsStepTooltipTopPosConditionsTablet : CheckRewardsStepTooltipTopPosConditions,
      defaultValue: isTablet ? 50 : 43,
    })}vh;
  left: 25vh;
`;

const tooltipSmallScreenPWA = css`
  left: 38vh;
  top: 55vh;
`;

const topLayerSmallScreen = css`
  height: ${({ $windowHeight }) =>
    getResponsiveValue({
      windowHeight: $windowHeight,
      conditions: isTablet ? CheckRewardsStepTopLayerHeightConditionsTablet : CheckRewardsStepTopLayerHeightConditions,
      defaultValue: isTablet ? 65.5 : 57,
    })}vh;
  left: 50vh;
  width: ${isTablet ? 35 : 31}vh;
`;

const topLayerSmallScreenPWA = css`
  left: 59vh;
  height: 72vh;
`;

const bottomLayerSmallScreen = css`
  margin-top: ${({ $windowHeight }) =>
    getResponsiveValue({
      windowHeight: $windowHeight,
      conditions: isTablet ? CheckRewardsStepBottomLayerTopConditionsTablet : CheckRewardsStepBottomLayerTopConditions,
      defaultValue: isTablet ? 66 : 56,
    })}vh;
  left: 50vh;
  width: ${isTablet ? 35 : 31}vh;
`;

const bottomLayerSmallScreenPWA = css`
  left: 59vh;
`;

const rightLayerSmallScreen = css`
  left: ${isTablet ? 85 : 81}vh;
`;

const rightLayerSmallScreenPWA = css`
  left: 98.6vh;
`;

const leftLayerSmallScreen = css`
  width: 50vh;
`;

const leftLayerSmallScreenPWA = css`
  width: 59vh;
`;

export const CHECK_REWARD = {
  TOOLTIP: styled(Tooltip)`
    width: 50vh;
    top: 59vh;
    left: 30vh;
    @media only screen and (min-height: 750px) {
      top: 57vh;
      ${isNotStandaloneMobilePWA && tooltipSmallScreen}
      ${!isTablet && isStandalonePWA && tooltipSmallScreenPWA}
    }

    @media only screen and (min-height: 950px) {
      top: 55vh;
      ${isNotStandaloneMobilePWA && tooltipSmallScreen}
    }
    ${isNotStandaloneMobilePWA && tooltipSmallScreen}
    ${!isTablet && isStandalonePWA && tooltipSmallScreenPWA}
  `,
  TOP: styled(ShadowLayer)`
    height: 73.1vh;
    width: 39.6vh;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left: 51vh;

    @media only screen and (min-height: 800px) {
      height: 71.2vh;
      ${isNotStandaloneMobilePWA && topLayerSmallScreen}
    }

    @media only screen and (min-height: 930px) {
      height: 70.5vh;
      ${isNotStandaloneMobilePWA && topLayerSmallScreen}
    }

    @media only screen and (min-height: 1130px) {
      height: 69vh;
    }
    ${isNotStandaloneMobilePWA && topLayerSmallScreen}
    ${!isTablet && isStandalonePWA && topLayerSmallScreenPWA}
  `,
  BOTTOM: styled(ShadowLayer)`
    height: ${isNotStandaloneMobilePWA ? 30 : 20}vh;
    width: 39.6vh;
    top: 77px;
    margin-top: 73.4vh;
    bottom: 0px;
    right: 0px;
    left: 51vh;
    border-bottom-color: #fff;
    border-bottom-width: 4px;
    ${isNotStandaloneMobilePWA && bottomLayerSmallScreen}
    ${!isTablet && isStandalonePWA && bottomLayerSmallScreenPWA}
  `,
  RIGHT: styled(ShadowLayer)`
    top: 0px;
    bottom: 0px;
    width: 100vw;
    left: 90.6vh;
    ${isNotStandaloneMobilePWA && rightLayerSmallScreen}
    ${!isTablet && isStandalonePWA && rightLayerSmallScreenPWA}
  `,
  LEFT: styled(ShadowLayer)`
    top: 0px;
    bottom: 0px;
    width: 51vh;
    left: 0px;
    ${isNotStandaloneMobilePWA && leftLayerSmallScreen}
    ${!isTablet && isStandalonePWA && leftLayerSmallScreenPWA}
  `,
};

